// src/WiFi.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var WiFi_default = createIcon({
  displayName: "WiFi",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M12 5C7.858 5 4.10758 6.67858 1.39258 9.39258L3.33594 11.3359C5.63894 9.26994 8.67 8 12 8C15.33 8 18.3621 9.26894 20.6641 11.3359L22.6055 9.39453C19.8915 6.67953 16.142 5 12 5ZM12 10C9.221 10 6.68705 11.043 4.74805 12.748L6.86914 14.8691C8.26014 13.7041 10.049 13 12 13C13.951 13 15.7409 13.7031 17.1309 14.8691L19.25 12.75C17.312 11.044 14.779 10 12 10ZM12 15C10.6 15 9.31497 15.487 8.29297 16.293L12 20L15.707 16.293C14.685 15.487 13.4 15 12 15Z",
        fill: "currentColor"
      })
    ]
  })
});

export {
  WiFi_default
};
